import type { ReactElement } from "react";
import BackOverviewIcon from "static/images/BackOverviewIcon";
import Contract from "static/images/Contract";

interface ButtonItem {
  label?: string;
  icon?: ReactElement;
  path?: string;
}

export const actionButtons: ButtonItem[] = [
    { label: "Overview", icon: <BackOverviewIcon />, path: "" },
    { label: "Contracts", icon: <Contract />, path: "/manage-planning?filter=1" }
]